import cn from "classnames";
import { Select } from "components/shared/form";
import React, { useState } from "react";
import { addCars, getListForSelect } from "sources/books/usersGroups";

export default function AddGroup({ refreshData, carId, back }) {
    const [selectedGroup, setSelectedGroup] = useState({});
    const handleAdd = () => {
        if (!selectedGroup.id) {
            return;
        }
        addCars({ groupId: selectedGroup.id, carIds: [carId] }).then((res) => {
            if (res) {
                refreshData();
                back();
            }
        });
    };
    return (
        <div>
            <Select
                label="Группа"
                inputProps={{ name: "groupId" }}
                onChange={({ option }) => setSelectedGroup(option)}
                value={selectedGroup?.id}
                url={getListForSelect}
                propName="name"
                menuPortalTarget={document.body}
            />
            <div
                className={cn("btn btn-brand float-right", {
                    disabled: !selectedGroup.id,
                })}
                onClick={handleAdd}
            >
                Добавить
            </div>
        </div>
    );
}
